var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    [
      _c(
        "div",
        {
          staticClass: "parent mb-1",
          class: {
            selected: _vm.isSelected
          }
        },
        [
          _c(
            "span",
            { staticClass: "pt-1" },
            [
              !_vm.isOpen
                ? _c("vs-icon", {
                    attrs: { size: "small", icon: "keyboard_arrow_right" },
                    on: { click: _vm.toggle }
                  })
                : _vm._e(),
              _vm.isOpen
                ? _c("vs-icon", {
                    attrs: { size: "small", icon: "keyboard_arrow_down" },
                    on: { click: _vm.toggle }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "pt-1",
              on: {
                click: function($event) {
                  return _vm.selectFolder()
                }
              }
            },
            [
              !_vm.isOpen
                ? _c("font-awesome-icon", {
                    staticStyle: { color: "orange" },
                    attrs: { icon: ["fas", "folder"] }
                  })
                : _vm._e(),
              _vm.isOpen
                ? _c("font-awesome-icon", {
                    staticStyle: { color: "orange" },
                    attrs: { icon: ["fas", "folder-open"] }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "pt-1 text-sm pl-1",
              on: {
                click: function($event) {
                  return _vm.selectFolder()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.folder.nombre) + " ")]
          ),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass:
              "spinner-grow spinner-grow-sm text-purple h-4 w-4 mt-2 ml-2"
          })
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": "animated fadeIn",
            "leave-active-class": "animated fadeOut"
          }
        },
        [
          _vm.isOpen
            ? _c(
                "ul",
                {
                  staticClass:
                    "border-0 border-l-2 border-double left-0 pl-3 border-grey-light"
                },
                _vm._l(_vm.subFolders, function(folder) {
                  return _c("rs-folder-tree", {
                    key: folder.carpetaId,
                    attrs: { folder: folder, "repository-id": _vm.repositoryId }
                  })
                }),
                1
              )
            : _vm._e()
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": "animated fadeIn",
            "leave-active-class": "animated fadeOut"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "w-100 mt-3"
            },
            [
              _c("b-skeleton", {
                staticClass: "bg-grey-light border-0 w-48 h-8 mb-3",
                attrs: { type: "input", animation: "fade" }
              }),
              _c("b-skeleton", {
                staticClass: "bg-grey-light border-0 w-32 h-8 mb-3",
                attrs: { type: "input", animation: "fade" }
              }),
              _c("b-skeleton", {
                staticClass: "bg-grey-light border-0 w-64 h-8 mb-3",
                attrs: { type: "input", animation: "fade" }
              }),
              _c(
                "div",
                { staticClass: "d-flex w-100" },
                [
                  _c("b-skeleton", {
                    staticClass: "bg-grey-light border-0 w-3 h-3 ml-3",
                    attrs: { type: "text", animation: "fade" }
                  }),
                  _c("b-skeleton", {
                    staticClass: "bg-grey-light border-0 w-3 h-3 ml-1",
                    attrs: { type: "text", animation: "fade" }
                  }),
                  _c("b-skeleton", {
                    staticClass: "bg-grey-light border-0 w-3 h-3 ml-1",
                    attrs: { type: "text", animation: "fade" }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }